import { useIsMobileHook } from '@teliaee/telia-common-components';
import { observer } from 'mobx-react';
import React from 'react';
import { ITableCellProps, Separator, TableCell } from 'telia-front-react';

const PrivateMobileDetailsTableCell = observer((props: ITableCellProps): React.JSX.Element => {
  const { isMobile } = useIsMobileHook();
  const { children, ...rest } = props;
  return (
    <TableCell {...rest}>
      {isMobile && <Separator color="invisible" spacing="xxsmall" />}
      {children}
      {isMobile && <Separator color="invisible" spacing="xxsmall" />}
    </TableCell>
  );
});

export default PrivateMobileDetailsTableCell;
